const toPositiveLayer = (value) => {
  const layer = Number(value)
  return Number.isInteger(layer) && layer > 0 ? layer : null
}

export const sortOrthophotosByLayer = (first, second) => {
  const firstLayer = first.status === 'Ready' ? toPositiveLayer(first.layer) : null
  const secondLayer = second.status === 'Ready' ? toPositiveLayer(second.layer) : null
  if (firstLayer === null && secondLayer === null) return 0
  if (firstLayer === null) return -1
  if (secondLayer === null) return 1
  return firstLayer - secondLayer
}

export const getReadyLayerItems = (items) =>
  items
    .filter((item) => item.status === 'Ready' && toPositiveLayer(item.layer) !== null)
    .sort((first, second) => Number(first.layer) - Number(second.layer))

const getLayerValues = (originalLayers) =>
  Object.values(originalLayers)
    .map(Number)
    .sort((first, second) => first - second)

export const canMoveLayer = (item, originalLayers, direction) => {
  const layerValues = getLayerValues(originalLayers)
  const currentIndex = layerValues.indexOf(Number(item.layer))
  if (layerValues.length <= 1 || currentIndex < 0) return false
  return direction === 'up' ? currentIndex > 0 : currentIndex < layerValues.length - 1
}

export const moveLayerItems = (items, item, originalLayers, direction) => {
  const layerValues = getLayerValues(originalLayers)
  const currentIndex = layerValues.indexOf(Number(item.layer))
  const targetIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1
  const targetLayer = layerValues[targetIndex]
  const originalLayer = originalLayers[item.orthophotoId]
  const targetId = Number(
    Object.keys(originalLayers).find(
      (orthophotoId) => Number(originalLayers[orthophotoId]) === targetLayer
    )
  )
  if (currentIndex < 0 || !targetLayer || !targetId) return items

  return items.map((orthophoto) => {
    if (orthophoto.orthophotoId === item.orthophotoId) {
      return { ...orthophoto, layer: targetLayer }
    }
    if (orthophoto.orthophotoId === targetId) {
      return { ...orthophoto, layer: originalLayer }
    }
    if (Object.prototype.hasOwnProperty.call(originalLayers, orthophoto.orthophotoId)) {
      return { ...orthophoto, layer: originalLayers[orthophoto.orthophotoId] }
    }
    return orthophoto
  })
}

export const restoreLayerItems = (items, originalLayers) =>
  items.map((item) =>
    Object.prototype.hasOwnProperty.call(originalLayers, item.orthophotoId)
      ? { ...item, layer: originalLayers[item.orthophotoId] }
      : item
  )

export const isPositiveLayer = (value) => toPositiveLayer(value) !== null
